const data = [
  {
    title: "HR Management Utility",
    subtitle: "CRUD on Employee Mangement",
    description: "Build with Spring MVC, RESTful using Jersey-Jackson",
    link: "https://github.com/the-dimensionless/HR-Management-Utility-SpringMVC",
    image: "./spring.jpg",
  },
  {
    title: "Spring Boot JPA Demo",
    subtitle: "Demo on Hibernate & JPA",
    description: "Build with Spring Boot, JPA and Hibernate",
    link: "https://github.com/the-dimensionless/Spring-Boot-JPA-Hibernate-H2-demo",
    image: "./spring-boot.png",
  },
  {
    title: "Spring Data Rest Demo",
    subtitle: "Employees REST API",
    description: "Build with Spring Boot, Spring Data REST",
    link: "https://github.com/the-dimensionless/Spring-Data-Rest-Demo-Employee",
    image: "./spring.jpg",
  },
  {
    title: "Event Management",
    subtitle: "Spring Data REST demo",
    description: "Build with Spring Data REST",
    link: "https://github.com/the-dimensionless/Spring-Data-Rest-Demo-EventManagement",
    image: "./spring.jpg",
  },
  {
    title: "AWS Lambda REST API",
    subtitle: "AWS Lambda",
    description: "",
    link: "https://github.com/the-dimensionless/AWS-Lambda-IntroductoryPractice-RESTAPI",
    image: "./lambda.png",
  },
  {
    title: "Image Management Utility",
    subtitle: "CRUD on Image Mangement",
    description: "Build with Spring MVC and Hibernate",
    link: "https://github.com/the-dimensionless/Image-Management-Utility-SONAR-JENKINS",
    image: "./spring.jpg",
  },
  {
    title: "Angular Notification Portal",
    subtitle: "FE Portal to create and subscribe to notifications",
    description:
      "Built with Angular FE and Spring Boot BE with Hibernate as the ORM",
    link: "https://github.com/the-dimensionless/Mock-Notification-System-MTD-frontend",
    image: "./angular.png",
  },
  {
    title: "Ticket Management Portal",
    subtitle: "Simple UI Dashboard with a use case for management of tickets",
    description:
      "Built with Angular FE and Spring Boot BE with Hibernate as the ORM",
    link: "https://github.com/the-dimensionless/Ticket-Management-Portal-frontend",
    image: "./angular.png",
  },
  {
    title: "Angular To Do List",
    subtitle: "Simple To Do List",
    description: "Built with Angular FE and Express with Sequelize as the ORM",
    link: "https://github.com/the-dimensionless/NagarroFresherTraining_2020",
    image: "./angular.png",
  },
  {
    title: "React Manage Appointments",
    subtitle: "CRUD to manage appointments",
    description: "Based on React Course by Ray Ray Villalobos",
    link: "https://github.com/the-dimensionless/Intro-to-React-JS-Building-An-Interface-Course",
    image: "./logo192.png",
  },
  {
    title: "RN Stickers Bottom Sheer",
    subtitle: "Select Stickers and apply",
    description: "React Native Bottom Sheet use case",
    link: "https://github.com/the-dimensionless/Sticker-Picker-Play-ReactNative",
    image: "./logo192.png",
  },
  {
    title: "RN Animations",
    subtitle: "Simple Animations using RN",
    description: "React Native Animations",
    link: "https://github.com/the-dimensionless/rn-animations",
    image: "./logo192.png",
  },
  {
    title: "React Blog App To DO List",
    subtitle: "CRUD",
    description: "Using React, Redux & Local Storage",
    link: "https://github.com/the-dimensionless/BlogApp-React-Redux-LocalStorage",
    image: "./logo192.png",
  },
  {
    title: "Electron Fundamentals",
    subtitle: "Simple Apps using Electron JS",
    description: "",
    link: "https://github.com/the-dimensionless/Electron",
    image: "./electron.png",
  },
  // {
  //     title: 'NLP Python',
  //     subtitle: 'Rule based Chatbot & NLTK summarization',
  //     description: 'Python NLP',
  //     link: 'https://github.com/the-dimensionless/NLP_with_Python',
  //     image: './logo192.png'
  // },
];

export const skills = [
  "React JS",
  "React Native",
  "Spring Boot",
  "Hibernate",
  "Angular",
  "Node",
];

export const testimonials = [
  {
    quote: "As a Team Player, actively contributes to growth of team",
    image: "./sweta-chaurasia.jpg",
    name: "Shweta Chaurasia",
    company: "Nagarro",
  },
  {
    quote: "Diligent and actively learning!",
    image: "./ankur-nigam.jpg",
    name: "Ankur Nigam",
    company: "Nagarro",
  },
  {
    quote: "Responsible with in depth knowledge",
    image: "./zeeshan-danish.jpg",
    name: "Zeeshan Danish",
    company: "TCS",
  },
  {
    quote: "Great guy to have on team",
    image: "./narayan-krishna.jpg",
    name: "Narayan Krishna",
    company: "Nagarro",
  },
];

export default data;
